import { render, staticRenderFns } from "./six3.vue?vue&type=template&id=aa7e4a08&"
import script from "./six3.vue?vue&type=script&lang=js&"
export * from "./six3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports